import { useMutation, gql } from "@apollo/client"
import { GROUP_FIELDS } from "../groups"
import { LOCATION_FIELDS } from "../locations"
import { ADMINABLE_USERS_FIELDS } from "../users"
import { INTEGRATION_FIELDS } from "./useQueryIntegrations"

const INTEGRATION_MUTATION_ENABLE_EVENT = gql`
  mutation IntegrationEnableEvent($id: ID!, $event: String!) {
    integration(id: $id) {
      enableEvent(event: $event) {
        ${INTEGRATION_FIELDS}
      } 
    }
  }
`

const INTEGRATION_MUTATION_DISABLE_EVENT = gql`
  mutation IntegrationDisableEvent($id: ID!, $event: String!) {
    integration(id: $id) {
      disableEvent(event: $event) {
        ${INTEGRATION_FIELDS}
      } 
    }
  }
`

const INTEGRATION_MUTATION_RUN_OPERATION = gql`
  mutation IntegrationRunOperation($id: ID!, $method: String!) {
    integration(id: $id) {
      runOperation(method: $method) {
        message
      }
    }
  }
`

const PAUSE_INTEGRATION_MUTATION = gql`
  mutation IntegrationPause($id: ID!) {
    integration(id: $id) {
      pause {
        ${INTEGRATION_FIELDS}
      } 
    }
  }
`

const RESUME_INTEGRATION_MUTATION = gql`
  mutation IntegrationResume($id: ID!) {
    integration(id: $id) {
      resume {
        ${INTEGRATION_FIELDS}
      } 
    }
  }
`

const DISABLE_INTEGRATION_MUTATION = gql`
  mutation IntegrationDisable($id: ID!) {
    integration(id: $id) {
      disable
    }
  }
`

const SET_LOCATION_ATTRIBUTE = gql`
  ${LOCATION_FIELDS}
  mutation IntegrationSetLocationAttribute($id: ID!, $location: ID!, $key: String!, $value: String) {
    integration(id: $id) {
      setLocationAttribute(location: $location, key: $key, value: $value) {
        ...LocationFields
      }
    }
  }
`

const SET_LOCATION_GROUP_ATTRIBUTE = gql`
  mutation IntegrationSetLocationGroupAttribute($id: ID!, $location: ID!, $group: ID!, $key: String!, $value: String) {
    integration(id: $id) {
      setLocationGroupAttribute(location: $location, group: $group, key: $key, value: $value) {
        ${GROUP_FIELDS}
      }
    }
  }
`

const SET_USER_ATTRIBUTE = gql`
  ${ADMINABLE_USERS_FIELDS}
  mutation IntegrationSetUserAttribute($id: ID!, $user: ID!, $key: String!, $value: String) {
    integration(id: $id) {
      setUserAttribute(user: $user, key: $key, value: $value) {
        ...AdminableUsersFields
      }
    }
  }
`

const useMutationIntegrationEnableEvent = () => useMutation(INTEGRATION_MUTATION_ENABLE_EVENT)

const useMutationIntegrationDisableEvent = () => useMutation(INTEGRATION_MUTATION_DISABLE_EVENT)

const useMutationIntegrationRunOperation = () => useMutation(INTEGRATION_MUTATION_RUN_OPERATION)

const useMutationPauseIntegration = () => useMutation(PAUSE_INTEGRATION_MUTATION)

const useMutationResumeIntegration = () => useMutation(RESUME_INTEGRATION_MUTATION)

const useMutationDisableIntegration = () => useMutation(DISABLE_INTEGRATION_MUTATION)

const useMutationIntegrationSetLocationAttribute = () => useMutation(SET_LOCATION_ATTRIBUTE)

const useMutationIntegrationSetLocationGroupAttribute = () => useMutation(SET_LOCATION_GROUP_ATTRIBUTE)

const useMutationIntegrationSetUserAttribute = () => useMutation(SET_USER_ATTRIBUTE)

export {
  useMutationIntegrationEnableEvent,
  useMutationIntegrationDisableEvent,
  useMutationIntegrationRunOperation,
  useMutationPauseIntegration,
  useMutationResumeIntegration,
  useMutationDisableIntegration,
  useMutationIntegrationSetLocationAttribute,
  useMutationIntegrationSetLocationGroupAttribute,
  useMutationIntegrationSetUserAttribute,
}
